<template>
  <button
    class="market-settings-button"
    :class="{
      'market-settings-button--disabled': disabled,
      'market-settings-button--theme-details': theme === 'details',
    }"
    aria-label="Open Trade Experience Settings"
    @click="onToggle"
  ></button>
</template>

<script src="./market-settings-button.js"></script>
<style src="./market-settings-button.scss" lang="scss"></style>
